import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-all-catalogue',
  templateUrl: './all-catalogue.page.html',
  styleUrls: ['./all-catalogue.page.scss'],
})
export class AllCataloguePage implements OnInit {
  public catalogues = [];
  public data = undefined;
  private _domainId = environment.domainId;

  constructor(
    private httpSv: HttpService
  ) { }

  async ngOnInit() {
    const res = await this.httpSv.itemIndex('catalogue/all', `${this._domainId}/2`);
    this.data = res.section;
    this.catalogues = res.data;
    
  }

}
